import $ from "jquery";
window.$ = window.jQuery = $;
import Cookies from "js-cookie";

export const liPassInit = () => {
	const pass = new PassFactory.Pass({
		env: WPvars.envID,
		gameID: WPvars.gameID,
		appID: WPvars.appID,
		accountPlatType: WPvars.accpt,
		hostCAcc: WPvars.hostca,
		langType: "en",
		config: {
			isMobile: true,
		},
	});

	const menu = $(".nav-user");
	const dialog = $(".dialog");
	const user_name = $(".nav-user-name .li-pass-in");
	const user_avatar = $(".nav-user-avatar .li-pass-in img");
	const li_user_name = Cookies.get("lip_user_name", { domain: ".levelinfinite.com", secure: true });
	const li_user_avatar = Cookies.get("lip_picture_url", { domain: ".levelinfinite.com", secure: true });
	const li_openid = Cookies.get("lip_openid", { domain: ".levelinfinite.com", secure: true });
	const li_channelid = Cookies.get("lip_channelid", { domain: ".levelinfinite.com", secure: true });
	const li_token = Cookies.get("lip_token", { domain: ".levelinfinite.com", secure: true });
	const li_expire_time = Cookies.get("lip_expire_time", { domain: ".levelinfinite.com", secure: true });

	if (li_openid) {
		menu.addClass("active");
		dialog.removeClass("active");
	}

	if (li_user_name) {
		user_name.text(li_user_name);
	}

	if (li_user_avatar === "") {
		user_avatar.parent().toggleClass("default");
	} else {
		user_avatar.attr("src", li_user_avatar);
	}

	pass.start("#infinite-pass-component").then((userInfo) => {
		menu.addClass("active");
	});

	pass.on("onLogin", (userInfo) => {
		menu.addClass("active");
		dialog.removeClass("active");

		const li_logined = Cookies.get("logined_account_cache_key");
		Cookies.set("lip_logined_account_cache_key", li_logined, { domain: ".levelinfinite.com", secure: true });

		Cookies.set("lip_user_name", userInfo.user_name, { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_picture_url", userInfo.picture_url, { domain: ".levelinfinite.com", secure: true });

		Cookies.set("lip_openid", userInfo.openid, { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_channelid", WPvars.accpt, { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_token", userInfo.token, { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_expire_time", userInfo.token_expire_time, { domain: ".levelinfinite.com", secure: true });

		var PHPCookies = Cookies.withConverter({
			read: (value) => value,
			write: (value) => encodeURIComponent(value).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`),
		});
		PHPCookies.set("lip_openid", userInfo.openid);
		PHPCookies.set("lip_channelid", WPvars.accpt);
		PHPCookies.set("lip_token", userInfo.token);
		PHPCookies.set("lip_expire_time", userInfo.token_expire_time);

		user_name.text(li_user_name);
		user_avatar.attr("src", li_user_avatar);

		location.reload();
	});

	pass.on("onRegister", (userInfo) => {
		menu.addClass("active");
		dialog.removeClass("active");

		const li_logined = Cookies.get("logined_account_cache_key");
		Cookies.set("lip_logined_account_cache_key", li_logined, { domain: ".levelinfinite.com", secure: true });

		Cookies.set("lip_user_name", userInfo.user_name, { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_picture_url", userInfo.picture_url, { domain: ".levelinfinite.com", secure: true });

		Cookies.set("lip_openid", userInfo.openid, { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_channelid", WPvars.accpt, { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_token", userInfo.token, { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_expire_time", userInfo.token_expire_time, { domain: ".levelinfinite.com", secure: true });

		var PHPCookies = Cookies.withConverter({
			read: (value) => value,
			write: (value) => encodeURIComponent(value).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`),
		});
		PHPCookies.set("lip_openid", userInfo.openid);
		PHPCookies.set("lip_channelid", WPvars.accpt);
		PHPCookies.set("lip_token", userInfo.token);
		PHPCookies.set("lip_expire_time", userInfo.token_expire_time);

		user_name.text(li_user_name);
		user_avatar.attr("src", li_user_avatar);

		location.reload();
	});
};

export const liPassWidget = () => {
	const dialog = $(".dialog");
	const logout = $(".li-logout");

	$(".nav-user").on("click", function (evt) {
		if ($(this).is(":not(.active)")) {
			dialog.addClass("active");
		}
	});

	$(".dialog-close").on("click", function (evt) {
		dialog.removeClass("active");
	});

	$(logout).on("click", function (evt) {
		Cookies.set("lip_openid", "", { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_channelid", "", { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_token", "", { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_expire_time", "", { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_user_name", "", { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_picture_url", "", { domain: ".levelinfinite.com", secure: true });
		Cookies.set("lip_logined_account_cache_key", "", { domain: ".levelinfinite.com", secure: true });

		Cookies.set("lip_openid", "", { domain: "www.levelinfinite.com", secure: true });
		Cookies.set("lip_channelid", "", { domain: "www.levelinfinite.com", secure: true });
		Cookies.set("lip_token", "", { domain: "www.levelinfinite.com", secure: true });
		Cookies.set("lip_expire_time", "", { domain: "www.levelinfinite.com", secure: true });
		Cookies.set("lip_user_name", "", { domain: "www.levelinfinite.com", secure: true });
		Cookies.set("lip_picture_url", "", { domain: "www.levelinfinite.com", secure: true });
		Cookies.set("logined_account_cache_key", "", { domain: "www.levelinfinite.com", secure: true });

		location.reload();
	});
};
